import { useState } from "react";
import { Sunrise, Loader2, Square } from "lucide-react";
import { toast } from "sonner";
import { http, emitRefresh } from "@/lib/api";
import { speak, stopSpeaking } from "@/hooks/useVoice";

export const BriefingButton = ({ onText }) => {
  const [state, setState] = useState("idle");
  const go = async () => {
    if (state === "speaking") { stopSpeaking(); return setState("idle"); }
    setState("loading");
    try {
      const { data } = await http.post("/briefing");
      onText(data.text);
      emitRefresh();
      setState("speaking");
      await speak(data.text);
    } catch { toast.error("Briefing failed"); }
    setState("idle");
  };
  return (
    <button className="hud-btn !px-5 !py-3 shadow-[0_0_18px_rgba(255,154,77,0.25)]" onClick={go} disabled={state === "loading"} data-testid="morning-briefing-button">
      {state === "loading" ? <Loader2 size={16} className="animate-spin" /> : state === "speaking" ? <Square size={14} fill="currentColor" /> : <Sunrise size={16} />}
      {state === "loading" ? "Compiling briefing…" : state === "speaking" ? "Stop briefing" : "Good morning, sir"}
    </button>
  );
};
